<template>
    <form class="row align-items-center" enctype="application/x-www-form-urlencoded" @submit.prevent="onSearch" @reset.prevent="onReset">
        <div class="col">
            <input
                type="text"
                class="form-control"
                v-model="form.search"
                :placeholder="$t('search.search')"
                @keydown.enter="onSearch"
            >
        </div>

        <slot />

        <div class="col-md-2 ps-md-0 mt-md-0 mt-2">
            <div class="d-flex flex-row flex-nowrap align-items-center">
                <ResetButton class="w-100 me-1"/>
                <SubmitButton :disabled="disableSubmit" class="w-100"/>
            </div>
        </div>
    </form>
</template>

<script setup lang="ts">
import {useForm,router} from "@inertiajs/vue3";
import SubmitButton from "@/components/buttons/SubmitButton.vue";
import ResetButton from "@/components/buttons/ResetButton.vue";
import {computed} from "vue";

type Extra = {[key: string] : any}

const { search = null, only = [], url, extra = {} } = defineProps<{
    search?: string,
    only?: string[],
    url: string,
    extra?: Extra
}>()

const form =useForm({
    search: search
})

const disableSubmit = computed(() => {
    return form.processing
})

const onSearch = () => {
    form
        .transform(data => ({
            ...data,
            ...extra
        }))
        .get(url, {
        only: only
    })
}

const onReset = () => {
    form.reset()
    router.get(url, {}, {
        only: only
    })
}
</script>

<style scoped>

</style>
